export type ImageSize = 128 | 512;
export type ImageFormat = 'webp' | 'jpg';

const MAIN_VARIANT_SUFFIX = '_512.webp';

export abstract class ImageUtils {
  static readonly SIZES: ImageSize[] = [128, 512];
  static readonly MAIN_VARIANT_SUFFIX = MAIN_VARIANT_SUFFIX;

  static hasVariants(url?: string | null): boolean {
    return !!url && url.endsWith(MAIN_VARIANT_SUFFIX);
  }

  static variant(url: string, size: ImageSize, format: ImageFormat = 'webp'): string {
    if (!ImageUtils.hasVariants(url)) {
      return url;
    }
    return url.slice(0, -MAIN_VARIANT_SUFFIX.length) + `_${size}.${format}`;
  }

  static variantForPixels(url: string, px: number): string {
    return ImageUtils.variant(url, px <= 128 ? 128 : 512);
  }
}
